
import Typography from '@/ui-kit/components/typography';
import { TypographyType, TypographyProperty } from '@/ui-kit/components/typography/enums';
import TabList from '@/ui-kit/components/tab-list';
import { TabListProperty, TabListEventType } from '@/ui-kit/components/tab-list/enums';
import { StyleFontWeightType } from '@/ui-kit/styles/enums';
import ListingTransactionHistoryProps from './mixins/ListingTransactionHistoryProps';
import { ListingTransactionHistoryEventType, ListingTransactionHistoryProperty } from './enums';
import ListingTransactionHistoryTab from './tab';
import { track } from '@/utils/analytics';

export default {
  name: 'ListingTransactionHistory',
  components: {
    Typography,
    TabList,
    ListingTransactionHistoryTab,
  },
  mixins: [ListingTransactionHistoryProps],
  data() {
    return {
      TypographyProperty,
      TypographyType,
      TabListProperty,
      TabListEventType,
      StyleFontWeightType,
      ListingTransactionHistoryProperty,
    };
  },
  computed: {
    activeIndex() {
      return this.tabs
        .findIndex(({ id }) => id === this[ListingTransactionHistoryProperty.ActiveListingId]);
    },
  },
  methods: {
    handleTabChange(index) {
      track(`${this[ListingTransactionHistoryProperty.Origin]}_Sold Property_Tab click`, {
        listingId: this[ListingTransactionHistoryProperty.ActiveListingId],
        listingType: this[ListingTransactionHistoryProperty.Origin],
      });

      this.$emit(
        ListingTransactionHistoryEventType.TransactionChange,
        this[ListingTransactionHistoryProperty.Tabs][index].id,
      );
    },
  },
};
